import { render, staticRenderFns } from "./ShowroomSkeletonAnimate.vue?vue&type=template&id=1b3fd7e3"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports